<template>
  <v-container
    id="department"
    fluid
    tag="section"
  >
    <filter-form :filter-form="filterForm" :schoolLevels="schoolLevels" />
    <department-table :departments="departments" :schoolLevels="schoolLevels" />
    <common-no-result
      v-if="!loading && totalItem === 0"
    />
    <v-row class="mt-4">
      <v-col
        cols="12"
        sm="6"
      />
      <v-col
        cols="12"
        sm="6"
      >
        <v-pagination
          v-if="totalItem > limit"
          v-model="currentPage"
          class="justify-sm-end"
          :length="getTotalItem(totalItem)"
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
        />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import FilterForm from './components/FilterForm.vue'
  import DepartmentTable from './components/DepartmentTable'
  import RepositoryFactory from '../../repositories/RepositoryFactory'

  const DepartmentRepository = RepositoryFactory.get('department')
  const SchoolLevelRepository = RepositoryFactory.get('school_level')
  export default {
    components: { FilterForm, DepartmentTable },
    data () {
      return {
        filterForm: {
          keyword: '',
          schoolLevelIds: []
        },
        currentPage: 1,
        limit: 10,
        totalItem: 0,
        departments: [],
        loading: false,
        schoolLevels: []
      }
    },
    watch: {
      currentPage: {
        handler () {
          this.getDepartmentList()
        },
      },
      limit: {
        handler () {
          if (this.currentPage === 1) {
            this.getDepartmentList()
          } else {
            this.currentPage = 1
          }
        },
      },
    },
    async created () {
      await this.getListSchoolLevel()
      this.getDepartmentList()
      Bus.$on('department-list-filter', (filterForm) => {
        this.filterForm = filterForm
        this.currentPage = 1
        this.getDepartmentList()
      })
      Bus.$on('department-list-reload', () => {
        this.getDepartmentList()
      })
    },
    beforeDestroy () {
      Bus.$off('department-list-filter')
    },
    methods: {
      async getDepartmentList () {
        this.loading = true
        const params = {
          limit: this.limit,
          page: this.currentPage - 1,
          keyword: this.filterForm.keyword,
          schoolLevelIds: this.filterForm.schoolLevelIds
        }
        const loader = this.$loading.show()
        const response = await DepartmentRepository.list(params)
        loader.hide()
        this.loading = false
        if (response.success) {
          this.departments = _.get(response, 'data', [])
          this.totalItem = response.totalItem
        }
      },
      async getListSchoolLevel() {
        const res = await SchoolLevelRepository.list({limit: 1000})
        if (res.success) {
          this.schoolLevels = _.get(res, 'data', [])
        } else {
          this.schoolLevels = []
        }
      }
    },
  }
</script>
